// generated by the plop

import { DebtModel } from 'shared';
import { PROGRESS_STATUSES, UUID } from 'symbols';

export interface DebtManageStateModel {
  currentDebtId: UUID;
  debts: { [debtId: string]: DebtModel };
  loadDebtStatus: PROGRESS_STATUSES;
  updateDebtStatus: PROGRESS_STATUSES;
  realVersionDebts: { [debtId: string]: DebtModel };
}

export const DEBT_MANAGE_STATE_DEFAULT: DebtManageStateModel = {
  currentDebtId: null,
  debts: {},
  loadDebtStatus: PROGRESS_STATUSES.NOT_INITIALIZED,
  updateDebtStatus: PROGRESS_STATUSES.NOT_INITIALIZED,
  realVersionDebts: {}
};
